
namespace GeniuzPOS.Inventory {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class IcStockApproveDisassembleDialog extends Serenity.EntityDialog<IcStockApproveDisassembleRow, any> {
        protected getFormKey() { return IcStockApproveDisassembleForm.formKey; }
        protected getIdProperty() { return IcStockApproveDisassembleRow.idProperty; }
        protected getLocalTextPrefix() { return IcStockApproveDisassembleRow.localTextPrefix; }
        protected getNameProperty() { return IcStockApproveDisassembleRow.nameProperty; }
        protected getService() { return IcStockApproveDisassembleService.baseUrl; }
        protected getDeletePermission() { return IcStockApproveDisassembleRow.deletePermission; }
        protected getInsertPermission() { return IcStockApproveDisassembleRow.insertPermission; }
        protected getUpdatePermission() { return IcStockApproveDisassembleRow.updatePermission; }

        protected form = new IcStockApproveDisassembleForm(this.idPrefix);

        constructor() {
            super();
            this.form = new IcStockApproveDisassembleForm(this.idPrefix);
            (this.form.IcStockApproveDisassembleDtList.view as any).onDataChanged.subscribe(() => {
                let self = this;
                //ui-state-default slick-footerrow-column l0 r0 frozen
                self.element.find(".ui-state-default.slick-footerrow-column.l0.r0.frozen").html("รวม");
            });

            // this.form.RefDocNo1.change(e => {
            //     var skucode = Q.toId(this.form.RefDocNo1.value);                
               
            //     var orderNo = this.form.RefDocNo1.value;

            //     if(!Q.isEmptyOrNull(orderNo)){

            //         this.form.SetItemCode.value = (IcStockSetAssembleRow.getLookup().itemById[orderNo].SetItemCode)  
            //         this.form.SetQty.value = (IcStockSetAssembleRow.getLookup().itemById[orderNo].SetQty)  
                    
            //         this.form.IcStockApproveDisassembleDtList.SetItemCode = this.form.RefDocNo1.value;
            //             // const getPO = Q.first(this.form.SetItemCode.items, x=> (x.source as Product.PsSetItemRow).SetItemCode == orderNo);
            //             // this.setPurOrderDetails(getPO.source);
            //         this.form.IcStockApproveDisassembleDtList.refresh();
            //     }else{
            //         this.form.IcStockApproveDisassembleDtList.clearDataGrid();
            //     }
            //     // this.form.SetQty.value =1
            
            // });

            // this.form.SetQty.changeSelect2(e => {
            //     var orderNo = this.form.SetQty.value;
            //     console.log("order: " + orderNo);
            //     var orderNo0 = this.form.RefDocNo1.value;
            //     if(!Q.isEmptyOrNull(orderNo0)){
            //             let set = (IcStockSetAssembleRow.getLookup().itemById[orderNo0].SetQty)  
            //             let use = (IcStockSetAssembleRow.getLookup().itemById[orderNo0].QtyUse)
            //             console.log("set:"+set+".use:"+use)

            //             var checkmax = set - use
            //     if(orderNo > 0){
            //         if( orderNo < checkmax ){
            //         this.form.IcStockApproveDisassembleDtList.QtySetItem = this.form.SetQty.value;
            //             // const getPO = Q.first(this.form.SetItemCode.items, x=> (x.source as Product.PsSetItemRow).SetItemCode == orderNo);
            //             // this.setPurOrderDetails(getPO.source);
            //         this.form.IcStockApproveDisassembleDtList.refresh();
            //     }else{
            //         Q.warning("เพิ่ม จำนวนชุดได้เท่ากับ "+checkmax + " ไม่สามารถมากกว่าจำนวนเดิมได้")
            //         this.form.SetQty.value = checkmax
            //     }
            //     }else{
            //         this.form.IcStockApproveDisassembleDtList.clearDataGrid();
            //     }}
            
            // });


        }
        protected getToolbarButtons(): Serenity.ToolButton[] {
            let buttons = super.getToolbarButtons();

            if (this.isEditMode) {
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "delete-button"), 1);
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);
               
                let newSavePosBtn: Serenity.ToolButton =  /// เอาไว้ใช้ขา Approve
                {
                    title: "อนุมัติ",
                    hint: "Approve and create Adjust Doc.",
                    separator: false,
                    cssClass: "button-Approve-post",
                    icon: "fa fa-save",
                    //hotkey: 'alt+shift+s',
                    onClick: (e) => {

                        var self = this;

                        this.form.CallAssemDocFg.value = 1; 
                        if (this.validateForm() && this.validateBeforeSave()) {
                            var options = this.getSaveOptions((response) => {

                                if (this.isEditMode()) {
                                    var id1 = response.EntityId;
                                    if (id1 == null) {
                                        id1 = this.get_entityId();
                                    }
                                    var a = this.loadById(id1);
                                }
                                else {
                                    var a = this.loadById(response.EntityId);
                                }

                        Q.confirm('ยืนยันการอนุมัติเอกสาร' + "\r\n" +
                            'เมื่ออนุมัติ ระบบจะทำการ สร้างเอกสาร ปรับปรุงเพิ่มและลดโดยอัตโนมัติ และสั่ง POST'
                            , () => {
                                this.form.ApproveFg.value = "1";

                                this.form.PostFg.value = "3";
                                // this.form.PostFg.forceUpdate();
                                // if (this.validateForm() && this.validateBeforeSave()) {
                                    var options = this.getSaveOptions((respons2) => {

                                        if (this.isEditMode()) {
                                            var id1 = respons2.EntityId;
                                            if (id1 == null) {
                                                id1 = this.get_entityId();
                                            }
                                            this.loadById(id1);
                                        }
                                        else {
                                            this.loadById(respons2.EntityId);
                                            // this.dialogClose();
                                        }

                                        this.showSaveSuccessMessage(respons2);


                                    });

                                    

                                    options.onError = function (respons2) {
                                        Q.alert(respons2.Error.Message);
                                    }

                                    Q.serviceCall(options);
                                // }
                                // this.showSaveSuccessMessage(respons2);



                            });

                        });

                        options.onError = function (response) {
                            Q.alert(response.Error.Message);
                        }

                        Q.serviceCall(options);
                    }






                    }
                }; buttons.push(newSavePosBtn);



                let newDeleteBtn: Serenity.ToolButton =
                {
                    title: "ลบเอกสาร'",
                    hint: "Delete",
                    separator: false,
                    cssClass: "delete-button",
                    icon: "fa fa-save",
                    hotkey: 'alt+x',
                    onClick: (e) => {
                        Q.confirm('ยืนยันการลบเอกสาร', () => {
                            this.form.CancelFg.value = "2";
                            this.save((response) => {
                                this.dialogClose();
                            });
                        });
                    }
                };
                buttons.push(newDeleteBtn);


            }
            buttons.push(
                {
                    title: Q.text("Close"),	// *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    hint: 'esc',
                    hotkey: 'esc',
                    onClick: () => {
                        this.dialogClose();

                    },
                }
            );

            return buttons;
        }

        protected afterLoadEntity() {
            super.afterLoadEntity();

           
            ////----
            let self = this;
            let nbrRetry = 0;
            (function changeTitle() {
                if (nbrRetry >= 10) {
                    return;
                }

                setTimeout(() => {
                    if ((self as any).isMarkedAsPanel === true) {
                        if (self.element.find(".panel-titlebar").length == 1) {
                            // self.element.find(".panel-titlebar").html("");
                            // self.element.find(".panel-titlebar-text").html("");
                            self.element.find(".panel-titlebar-close").html("");//panel-titlebar
                        }
                        else {
                            changeTitle();
                        }
                    }
                    else {
                        // if (self.element.parent().find(".panel-titlebar").length == 1) {
                        //     // self.element.parent().find(".panel-titlebar").html("");
                        //     // self.element.parent().find(".panel-titlebar-text").html("");
                        //     self.element.parent().find(".panel-titlebar-close").html("");
                        // }
                        // else {
                        //     changeTitle();
                        // }
                    }
                }, 100);
            })();
            if (this.entity.PostFg > 0  || this.entity.CancelFg == 1) {
                this.toolbar.findButton('delete-button').hide();
                this.toolbar.findButton('button-Approve-post').hide();
                this.toolbar.findButton('button-save').hide();
                this.deleteButton.toggleClass('disabled', true);
                this.form.IcStockApproveDisassembleDtList.set_readOnly(true);
            } else {


            }
        }


        // protected getSaveEntity(): IcStockApproveDisassembleRow {
        //     let entity = super.getSaveEntity();

        //     return entity;
        // }




    }
}